
const SiteLocation = () => {

  // get subdomain info here...???
  const Host = window.location.host
  const Protocol = window.location.protocol
  let parts = Host.split('.')
  let subdomain = null
  if ( parts.length >= 3 ){
    subdomain = parts[0]
  }

  let myHost = ''

  if ( subdomain === null ) {
    if ( Host === 'brotherhoodmutualcourses.com' ) {
      myHost = 'brotherhood.lmscourses.com'
    } else {
      myHost = 'staging.lmscourses.com'
    }
  } else if ( subdomain === 'www' ) {
    if ( Host === 'www.brotherhoodmutualcourses.com' ) {
      myHost = 'brotherhood.lmscourses.com'
    } else {
      myHost = String(Host)
    }

  } else {
    myHost = String(Host)
  }

  //alert(`Protocol: ${Protocol} myHost: ${myHost}`)


  return [ Protocol, myHost ]


}


export default SiteLocation
